import { Component, Injector } from '@angular/core';
import { AppFormComponent } from 'src/app/components/tuain/forms/app-form.component';

const frm = {
  name: 'notifications',
  fields: {
    notifications: 'notifications',
    id: 'id',
    notificationId: 'notificationId',
    title: 'title',
    body: 'body',
    type: 'type',
    date: 'date',
    status: 'status',
  },
  actions: {
    refreshNotifications: 'refreshNotifications',
    notificationsRead: 'notificationsRead',
  },
};

@Component({
  selector: 'app-topbar-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class TopbarNotificationsComponent extends AppFormComponent {
  badgeCount = 0;
  dropdownVisible = false;
  notificationList: any;

  override customPreProcessing() { this.formCode = frm.name; }

  override customFormStart() {
    this.subscribeAppEvents('pendingNotifications', num => this.updatePendingNotifications(num));
    this.subscribeAppEvents('notification', () => {
      this.startAction(frm.actions.refreshNotifications);
      // this.populateNotifications();
    });
    this.onActionFinish(frm.actions.refreshNotifications, () =>
      this.populateNotifications(),
    );
    this.onActionFinish(frm.actions.notificationsRead, () =>
      this.populateNotifications(),
    );
    this.populateNotifications();
  }

  populateNotifications() {
    const unreadNotitications = [];
    const notifications = this.getFieldValue(frm.fields.notifications);
    if (!notifications || !Array.isArray(notifications)) { return; }
    notifications.forEach((element) => {
      if (!element.status) {
        unreadNotitications.push(element);
      }
    });
    this.badgeCount = unreadNotitications?.length ?? 0;
    this.notificationList = notifications ?? [];
  }
  
  viewNotifications(item) {
    this.setFieldValue(frm.fields.id, item?.memberNotificationId);
    this.setFieldValue(frm.fields.notificationId, item?.id);
    this.setFieldValue(frm.fields.title, item?.title);
    this.setFieldValue(frm.fields.body, item?.body);
    this.setFieldValue(frm.fields.type, item?.type);
    this.setFieldValue(frm.fields.date, item?.date);
    this.setFieldValue(frm.fields.status, item?.status);
    this.startAction(frm.actions.notificationsRead);
    this.dropdownVisible = false;
  }

  viewAllNotifications() {
    this.openForm('notifications');
    this.dropdownVisible = false;
  }

  updatePendingNotifications(pendingNotifications) {
    if (this.badgeCount !== pendingNotifications) {
      this.startAction(frm.actions.refreshNotifications);
      this.badgeCount = pendingNotifications;
      // const notificationOption = this.menuOptions?.find(opt => opt.form === 'notifications') ?? null;
      // notificationOption && (notificationOption.badge = pendingNotifications);
      // this._eventManager.next('updateNotifications', pendingNotifications);
    }
  }
}
